import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";
import ProgramTable from "../container/Program/ProgramTable";

const handbookUrl = `${process.env.PUBLIC_URL}/files/ICSI2026_Program_Handbook.pdf`;

const Program = () => {
  return (
    <React.Fragment>
      <SEO title="Program | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Program"
        content="The Conference"
        contentTwo="Program"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content title-center">
          <h2>ICSI&apos;2026 Program Schedule</h2>
          <p>
            Venue: Vision Hotel (唯实国际文化交流中心), Beijing. All times are China
            Standard Time (UTC+8).
          </p>
          <p>
            <a
              className="btn btn-primary btn-hover-secondary mt-s"
              href={handbookUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Program Handbook (PDF)
            </a>
          </p>
        </div>
        <div className="entry-content title-center">
          <ProgramTable />
        </div>

        <div className="space-60"></div>

        <div className="entry-content2">
          <h4>Detailed Scheduled Presentations Timetables</h4>
          <Link
            className="btn btn-primary btn-hover-secondary mt-s"
            to={process.env.PUBLIC_URL + "/sessions"}
          >
            Sessions
          </Link>
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Program;
